var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"confirm"},[_c('h1',{staticClass:"confirm__message"},[_vm._v("Your account is being set up...")]),_c('div',{staticClass:"confirm__spinner-wrapper"},[_c('ActionLoader',{attrs:{"name":"ball-clip-rotate"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }